module.exports = __webpack_public_path__ + "static/media/Detective.881f9f2c.jpg";